import service from '../apihttp'
import config from '@/assets/config.json'


/* 订单管理***************************** */
export function orderlist(data) {
    const url = config.shopHttps.api + '/apiadministrator/order/list'
    return service.post(url, data)
}
//订单详情
export function orderListDetail(data) {
    const url = config.shopHttps.api + '/apiadministrator/order/detail'
    return service.post(url, data)
}
export function orderImport(data) {
    const url = config.shopHttps.api + '/apiadministrator/order/download'
    return service.post(url, data)
}

//推广订单列表
export function AduitRecommend(data) {
    const url = config.shopHttps.api + '/apiadministrator/order/activity/list'
    return service.post(url, data)
}
//推广订单导出
export function RecommendExport(data) {
    const url = config.shopHttps.api + '/apiadministrator/order/activity/export'
    return service.post(url, data)
}
//推广订单详情
export function AduitRecommendDetail(data) {
    const url = config.shopHttps.api + '/apiadministrator/order/activity/detail'
    return service.post(url, data)
}